import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.2126 0.825397L6 2.25397L3.95276 3L6 3.74603L5.1811 5.22222L3.48031 3.80952L3.84252 6H2.20472L2.55118 3.80952L0.866142 5.25397L0 3.73016L2.04724 2.98413L0.0157481 2.26984L0.818898 0.809524L2.56693 2.20635L2.20472 0H3.85827L3.48031 2.20635L5.2126 0.825397Z"
      fill="#7876C1"
    />
  </svg>
);

const Asterisk = (props) => <Icon component={svg} {...props} />;

export default Asterisk;
